namespace h5_vm {
   import VmProvisioningWizardPage = h5_vm.VmProvisioningWizardPage;

   export class VmProvisioningVservicePageService implements VmProvisioningPageService {

      static $inject: string[] = [
         "i18nService",
         "vuiConstants",
         "wizardPageService",
         "vmVuiWizardPageBuilder",
         "vmProvisioningVservicePageModel"
      ];

      constructor(private i18nService: any,
                  private vuiConstants: any,
                  private wizardPageService: any,
                  private vmVuiWizardPageBuilder: any,
                  private vmProvisioningVservicePageModel: any) {
      }

      public build(wizardScope: any,
                   defaultTarget?: any,
                   preselectedComputeResource?: any): VmProvisioningWizardPage {
         let pageModel = new this.vmProvisioningVservicePageModel(
               wizardScope.wizardViewData, wizardScope.vmParams);
         wizardScope.vmProvisioningScaleoutConfigurationPageModel = pageModel;

         return this.vmVuiWizardPageBuilder.buildVuiWizardPage(wizardScope.config, {
            title: this.i18nService.getString("ProvisioningUiLib", "VServicePage.title"),
            description: this.i18nService.getString("ProvisioningUiLib", "VServicePage.description"),
            contentUrl: "vm-ui/resources/vm/views/createVmWizard/deployOvfPages/" +
               "vmProvisioningVservice/vm-provisioning-vservice-page.html",
            model: pageModel,
            defaultState: this.vuiConstants.wizard.pageState.SKIPPED,
         });
      };
   }

   angular.module("com.vmware.vsphere.client.vm")
         .service("vmProvisioningVservicePageService",
               VmProvisioningVservicePageService);

}
